<template>
    <Toast/>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div :class="`card-header ${pageBox} page-header mb-2`">
            <div class="d-flex align-items-center align-content-center" style="height: inherit;">
                <h4 class="mb-0 text-white d-xs-none d-sm-none d-md-inline-block d-lg-inline-block d-xl-inline-block mr-2">Network Access&nbsp;&nbsp;</h4>
                <Select
                    v-model="selectedWhitelistId"
                    :options="availableWhitelists"
                    optionLabel="attributes.name"
                    option-value="id"
                    @change="changeWhitelist"
                    :placeholder="selectedWhitelist.attributes.name ? selectedWhitelist.attributes.name : 'Loading...'"
                    :dt="whitelistPickerStyle"
                    style="height: inherit;"
                    :label-class="'align-content-center'"
                    :loading="fetchingAvailableWhitelists"
                    >
                </Select>
            </div>


            <a href="javascript:" @click="$goBack" class="text-white" style="flex-grow: 0; flex-shrink: 0; margin-right: 10px;">
                <i :class="$t('app_back_icon')"></i>&nbsp;Back
            </a>
        </div>
        <whitelist-countries
            :key="this.selectedWhitelistId"
            :whitelist-id=this.selectedWhitelistId
        />


        <div class="col d-flex p-0">
            <whitelist-details
                :whitelist-id="selectedWhitelistId"
                :whitelist="whitelist"
                :editable="editable"
                @whitelist-updated="onWhitelistUpdated"
                @whitelist-fetch-error="onFetchError"
            />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <DynamicDatatableComponent
                :key="datatableRenderKey"
                resource="sims"
                type="datatable"
                title="Applied Sim Profiles"
                rows=10
                data-key="did"
                :whitelist-id=this.selectedWhitelistId
                advanced />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Toast from 'primevue/toast';
import DynamicDatatableComponent from "../Datatables/DynamicDatatableComponent.vue";
import WhitelistCountries from "./components/WhitelistCountries.vue";
import WhitelistDetails from "./components/WhitelistDetails.vue";
import Select from "primevue/select";

export default {
    name: 'WhitelistView',
    components: {
        Toast,
        Select,
        DynamicDatatableComponent,
        WhitelistCountries,
        WhitelistDetails,
    },
    props: {
        whitelistId: {
            type: String,
            required: true,
        },
        whitelist: {
            type: Object,
            default: null,
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            datatableRenderKey: 0,
            fetchingWhitelist: false,
            fetchingAvailableWhitelists: true,
            availableWhitelists: [],
            selectedWhitelistId: this.whitelistId,
            selectedWhitelist: this.whitelist,
            whitelistPickerStyle: {
                colorScheme: {
                    light: {
                        background: '{primary.50}',
                        border:{
                            color: '{primary.500}',
                            radius: '0px',
                        },
                        color: '{surface.1000}',
                        dropdownColor: '{surface.1000}',
                        focus: {
                            border: {
                                color: '{primary.600}'
                            },
                            ring: {
                                color: '{primary.300}',
                                shadow: '{primary.300}'
                            }
                        },
                        hover: {
                            border: {
                                color: '{primary.600}'
                            },
                            background: '{surface.50}',
                        },
                        fontSize: '14px',
                        label: {
                            color: '{surface.1000}',
                            font: {
                                weight: 300,
                                size: '14px',
                            }
                        },
                        option: {
                            color: '{surface.0}',
                            font: {
                                weight: 300,
                            },
                            selected: {
                                color: '{surface.0}'
                            },
                            selectedFont: {
                                weight: 300,
                                size: '14px',
                            }
                        },
                        placeholder: {
                            color: '{surface.1000}',
                            font: {
                                weight: 300,
                                size: '14px',
                            }
                        },
                        shadow: 'none',
                    }
                }
            }
        };
    },
    mounted() {
        if (!this.whitelist) {
            this.fetchWhitelist();
        }
        this.fetchAvailableWhitelists();
    },
    computed: {
        pageButton() {
            return this.$themeSettings.pageButton;
        },
        pageInfo() {
            return this.$themeSettings.pageInfo;
        },
        pageBox() {
            return this.$themeSettings.pageBox;
        },
    },
    watch: {

    },
    methods: {
        fetchAvailableWhitelists() {
            this.fetchingAvailableWhitelists = true;
            axios
                .get('/network-access/list', { headers: { Accept: 'application/json' } })
                .then((res) => {
                    this.availableWhitelists = res.data.data;
                })
                .catch((err) => this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to load whitelists', life: 3000 }))
                .finally(() => {
                    this.fetchingAvailableWhitelists = false;
                });
        },
        fetchWhitelist() {
            this.fetchingWhitelist = true;
            axios
                .get(`/network-access/${this.selectedWhitelistId}`, { headers: { Accept: 'application/json' } })
                .then((res) => {
                    this.selectedWhitelist = res.data.data;
                })
                .catch((err) => this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to load whitelist', life: 3000 }))
                .finally(() => {
                    this.fetchingWhitelist = false;
                    this.datatableRenderKey++;
                });
        },
        changeWhitelist() {
            this.$router.push(`/network-access/${this.selectedWhitelistId}`);
            this.datatableRenderKey++;
        },
        onWhitelistUpdated(notification) {
            // Refresh data
            this.fetchWhitelist();
            this.notify(notification);
        },
        onFetchError(notification) {
            this.notify(notification);
        },
        notify(notification) {
            this.$toast.add(notification);
        },
    },
};
</script>
<style scoped>
@media (max-width: 575.98px) {
    .d-xs-none {
        display: none !important;
    }
}
</style>
